import { Link } from "react-router-dom";


const Index = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-100 to-purple-50">
      <div className="text-center space-y-6">
        <h1 className="text-4xl font-bold mb-4">Welcome to Your App</h1>
        <p className="text-xl text-gray-600 mb-8">Get started by signing in or creating an account</p>
        <div className="space-x-4">
          <Link to="//">
            <button className="bg-purple-600 hover:bg-purple-700">Sign in</button>
          </Link>
          <Link to="/visiteurs/register">
            <button variant="outline">Create account</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Index;